import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.group-parent-container': {
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.surface.pricing,
        color: palette.text.highlight,
        '&:hover': {
          backgroundColor: palette.text.highlight,
          color: palette.surface.pricing,
        },
      },
    },
    '& .normal-text': {
      fontWeight: 400,
      fontFamily: 'Instrument Serif !important',
      fontSize: '88px !important',
      lineHeight: '88px !important',
      letterSpacing: '-1.76px !important',
      '@media screen and (max-width: 900px)': {
        fontSize: '64px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.28px !important',
      },
    },
    '& .hero-home-button': {
      color: palette.text.highlight,
      borderColor: palette.text.highlight,

      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      backgroundColor: palette.background.primary,
      color: palette.text.highlight,
      marginTop: 88,

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,

      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '68px',
    },
    '& .home-hero-wrapper': {
      width: '100vw',
      zIndex: 2,
      '& .section-alternate': {
        backgroundColor: palette.surface.pricing,
        '& .section-alternate__content': {
          objectFit: 'contain',
          display: 'flex',
          justifyContent: 'center',
          '& .section-header__cta-wrapper': {
            display: 'flex',
            flexDirection: 'row',
            maxWidth: '90vw',
          },
          zIndex: 3,
        },
      },
      '& .MuiGrid-container': {
        width: 878,
        display: 'flex',
        justifyContent: 'center',
        '@media screen and (max-width: 900px)': {
          width: '100%',
        },
      },

      '& .hero-background': {
        objectFit: 'cover',
        backgroundColor: palette.surface.header,
        '@media screen and (max-width: 900px)': {
          height: '450px',
        },
        '@media screen and (min-width: 2560px)': {
          objectFit: 'cover',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '600px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },

      '& .home-hero-title': {
        fontSize: 64,
        fontWeight: 600,
        justifyContent: 'center',
        textAlign: 'center',
        letterSpacing: '-1.28px',
        color: palette.text.highlight,
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
        },
        '& .home-hero-subtitle': {
          fontSize: 16,
          fontFamily: 'Brockmann',
          maxWidth: 550,
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      '& .section': {
        padding: '20px 16px !important',
        '@media screen and (max-width: 700px)': {
          padding: '0px 16px !important',
        },
      },
      '@media(max-width: 600px)': {
        padding: '20px !important',
      },
      backgroundColor: palette.surface.light,
      '& .benefits-wrapper': {
        '& .section-header__title': {
          fontWeight: 400,
          fontFamily: 'Instrument Serif !important',
          fontSize: '64px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.28px !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '48px !important',
            lineHeight: '48px !important',
            letterSpacing: '-0.96px !important',
          },
        },
        '& .customImageWrapper': {
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'center',
          '@media(max-width: 1200px)': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          left: '-500px',
        },
      },
      '& .section-alternate__content': {
        padding: '48px 80px',

        '@media screen and (max-width: 900px)': {
          padding: '48px 50px',
        },
        '@media screen and (max-width: 600px)': {
          padding: '48px 0px',
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'left',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
        '& .definition-service-innertile': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          '& .MuiGrid-justify-content-xs-center': {
            justifyContent: 'flex-start !important',
          },
        },
      },
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 30,
      },
      '& .definition-service-title': {
        padding: '10px 0px !important',
        fontWeight: 400,
        fontFamily: 'Instrument Serif !important',
        fontSize: '32px !important',
        lineHeight: '32px !important',
        letterSpacing: '-0.64px !important',
        textAlign: 'left !important',
      },
      '& .definition-service-description': {
        marginBottom: 0,
        textAlign: 'left !important',
      },
      '& .customIcon': {
        display: 'flex',
        justifyContent: 'flex-start !important',
        alignItems: 'flex-start !important',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
      },
      '& .section-header__title': {
        fontWeight: 400,
        fontFamily: 'Instrument Serif !important',
        fontSize: '72px !important',
        lineHeight: '64px !important',
        letterSpacing: '-2.16px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '48px !important',
          lineHeight: '48px !important',
          letterSpacing: '-0.96px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 500,
        fontFamily: 'Brockmann !important',
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.4px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
        },
      },
      '& .section-header__title, .section-header__subtitle, .summary-text, .summary-subtext, .subscription-tabs-label':
      {
        color: `${palette.text.highlight} !important`,
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .MuiButton-containedPrimary': {
            backgroundColor: palette.surface.planCard,
            color: palette.secondary.contrastText,
            '&:hover': {
              backgroundColor: palette.secondary.contrastText,
              color: palette.surface.planCard,
            },
          },
          '& .customcardTitle': {
            fontWeight: 400,
            fontFamily: 'Instrument Serif !important',
            fontSize: '32px !important',
            lineHeight: '32px !important',
            letterSpacing: '-0.64px !important',
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .summary-text': {
          fontWeight: 500,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
        '& .summary-subtext': {
          fontWeight: 500,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
        '& .savings-summary-link': {
          color: palette.primary.main,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,

      '& .cover-image-wrapper': {
        '& .how-it-works-image': {
          borderRadius: 24,
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          fontWeight: 400,
          fontFamily: 'Instrument Serif !important',
          fontSize: '64px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.28px !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '48px !important',
            lineHeight: '48px !important',
            letterSpacing: '-0.96px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 500,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '16px !important',
            lineHeight: '20px !important',
            letterSpacing: '-0.32px !important',
          },
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .how-cover-image': {
        backgroundSize: 'cover',
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.primary,
        color: palette.secondary.main,
        fontSize: 15,
      },

      '& .working-steps-container': {
        '& .step-title': {
          fontSize: 20,
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 500,
        },
        '& .step-content': {
          fontSize: 16,
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          fontWeight: 400,
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        backgroundColor: palette.surface.pricing,
      },
      '& .section-header': {
        '& .hero-header-title': {
          color: palette.text.contrastText,
          fontFamily: 'Instrument Serif !important',
          fontSize: '48px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.96px !important',
          fontWeight: 400,
        },
        '& .hero-header-subtitle': {
          fontFamily: 'Brockmann !important',
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 500,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        paddingInline: '0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.surface.light} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.primary,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: `${palette.surface.grey} !important`,
      },
      '& .section-header__title': {
        color: palette.text.primary,
        fontWeight: 400,
        fontFamily: 'Instrument Serif !important',
        fontSize: '64px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.28px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '48px !important',
          lineHeight: '48px !important',
          letterSpacing: '-0.96px !important',
        },
      },
      '& .section-header__subtitle': {
        color: palette.text.primary,
      },
      '& .MuiButton-containedPrimary': {
        backgroundColor: `${palette.surface.pricing} !important`,
        borderColor: palette.primary.main,
        color: palette.text.highlight,
        fontWeight: 500,
        fontSize: '16px !important',
        lineHeight: '20px !important',
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'Instrument Serif !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 400,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Brockmann !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 500,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      backgroundColor: palette.surface.pricing,
      '& .MuiButton-contained': {
        backgroundColor: palette.text.highlight,
        color: palette.text.primary,
      },
      '& .hero-header-title': {
        fontFamily: 'Instrument Serif !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 400,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Brockmann !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 500,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.surface.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 700px)': {
        paddingInline: '20px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontFamily: 'Instrument Serif !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 400,
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
      },
      '& .provider-contact-details': {
        fontSize: '24px !important',
        fontFamily: 'Instrument Serif !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.56px !important',
        fontWeight: 400,
      },
      '& .provider-contact-link': {
        color: palette.text.secondary,
        fontSize: 20,
        lineHeight: '24px !important',
        letterSpacing: '-0.4px !important',
        fontWeight: 500,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.surface.grey,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.primary,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.primary,
        color: palette.background.primary,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.background.primary, // Common border color for all states

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.background.primary} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.background.primary,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.background.primary} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.background.primary,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        fill: `${palette.background.main} !important`, // Filled background
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.background.primary, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.stepperCompleted} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      }
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      position: 'relative',
      paddingBottom: 20,
      paddingTop: 0,
      '@media(min-width: 900px)': {
        paddingInline: '80px !important',
      },
      '@media(max-width: 900px)': {
        paddingInline: '20px !important',
      },
      backgroundColor: palette.surface.pricing,
      color: palette.primary.contrastText,
      fontFamily: 'Brockmann !important',
      '& a': {
        color: palette.primary.contrastText,
      },
      '&::before': {
        content: '""',
        display: 'block',
        width: '100vw',
        height: '300px',
        padding: '0 !important',
        marginLeft: 'calc(-50vw + 50%)',
        marginRight: 'calc(-50vw + 50%)',
        backgroundImage: 'url(/images/home-images/footer-image.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        marginBottom: 0,
        '@media screen and (max-width: 900px)': {
          height: '200px',
        },
      },
    },
  },
};
